import React, { useEffect, useState } from "react";
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getCurrencieLabel } from "../../../../constants/currencies";
import { SelectTickets } from "../../../OpenSell/Steps";
import { ticketTypes } from "../../../../helpers/ticketHelper.ts";
import { getPrice, getAdministrativeFee } from "../../../../helpers/ticketPriceHelper.ts";
import { getTotal } from "../../helpers";
import { executeOrderPayment } from "../../../../helpers/paymentHelper/paymentHelper.ts";
import { getCurrentLanguageTexts } from "../../../../constants/seasonPassPersonalInfoLangs.js";
import TermsAndConditionsModal from "../../TermsAndConditionsModal/TermsAndConditionsModal.js";
import ls from 'localstorage-slim';
import axios from '../../../..//axios-instance.js';
import { getSeasonPassOptions } from "../../../../helpers/getSeasonPassOptions.js";
import NewLoader from "../../../../components/NewLoader/NewLoader.js";
import { getOc } from "../../../../helpers/optionalChain.ts";

const MySwal = withReactContent(swal);

export const ChangeSPSeatModal = ({ event, memberData, membershipCard, ticketTemplate, title }) => {
    const [state, setState] = useState({
        tickets: [],
        isLoading: false,
    });
    const [isTermsChecked, setTermsChecked] = useState(false);
    const [chart, setChart] = useState(null);
    const [productDefinition, setProductDefinition] = useState({});

    const txt = getCurrentLanguageTexts();

    const paymentAmount = getPrice(state.tickets) * (1 + getOc(productDefinition, '?.fee?.rate') || 0);

    const oldTicketTemplate = ticketTemplate;

    useEffect(() => {
        axios.get(`/ProductDefinition/${getSeasonPassOptions().changeDailyTicketSeatProductId}`, {
        }).then((r) => {
            setProductDefinition(
                r.data
            );
        })
    }, []);

    const confirmHandler = () => {
        setState({
            ...state,
            isLoading: true,
        });

        const redirectUrl = `${window.location.href}${window.location.href.includes('?') ? '&' : '?'}resultOrderId={Id}`;

        const ticket = state.tickets[0];
        const newTicketTemplateId = ticket.ticketTemplateId;

        executeOrderPayment({
            successUrl: redirectUrl,
            currency: 5,
            paymentMethod: 0, // led pay
            type: 4,// change daily seat
            ...memberData,
            products: [{
                productDefinitionId: productDefinition.id,
                body: JSON.stringify({
                    accessToken: ls.get('member-access-token'),
                    ticketId: membershipCard.id,
                    area: ticket.area,
                    side: ticket.side,
                    row: ticket.row,
                    seat: ticket.seat,
                    ticketTemplateId: newTicketTemplateId,
                })
            }]
        });
    }

    const onTicketAdded = (ticket) => {
        setState(state => {
            if (ticket.type === ticketTypes.NO_SEAT) {
                const tickets = [...state.tickets, ticket];

                return {
                    ...state,
                    tickets
                };
            }

            if (state.chart && !ticket.masterTicket &&
                (state.tickets.some(t => t.label === ticket.label)
                ) && ticket.type === ticketTypes.MAP) {
                return {
                    ...state
                };
            }

            const tickets = [...state.tickets, ticket];

            return {
                ...state,
                tickets
            };
        })
    };

    const onObjectDeselected = (ticket, manual = false) => {
        if (chart && ticket.type === ticketTypes.MAP) {
            chart.deselectObjects([ticket.label]);
        }

        if (chart && ticket.type === ticketTypes.MAP_NO_SEAT && manual) {
            chart.deselectObjects([{ label: ticket.label, amount: 1 }]);
            return;
        }

        setState(state => {
            if (ticket.type === ticketTypes.NO_SEAT) {
                const index = state.tickets.findIndex(i => i.ticketTemplateId === ticket.ticketTemplateId);

                return (
                    {
                        ...state,
                        tickets: state.tickets.filter((item, i) => i !== index),
                    });
            }
            else if (ticket.type === ticketTypes.MAP_NO_SEAT) {
                const index = state.tickets.findIndex(i => i.label === ticket.label);
                return (
                    {
                        tickets: state.tickets.filter((item, i) => i !== index),
                    }
                );
            }
            else if (ticket.type === ticketTypes.MAP) {
                return (
                    {
                        tickets: state.tickets.filter((item) => item.id !== ticket.id),
                    }
                );
            }
        });
    };

    const handleTermsChangeCheckbox = (a) => {
        setTermsChecked(!isTermsChecked);
    }

    const showTermsAndConditionsModal = (ev) => {
        ev.preventDefault();
        MySwal.fire({
            html: <TermsAndConditionsModal />,
            width: "64em",
            showCloseButton: true,
            customClass: "seasonpass__modal partizan-info-modal partizan-modal",
        });
    };

    const administrativeFee = getAdministrativeFee(state.tickets, getOc(productDefinition, '?.fee?.fixedByPosition') || 0, getOc(productDefinition, '?.fee.?.rate') || 0);

    return <section className="buy-ticket-modal">
        <h2 className="first-title">{title}</h2>

        <div className="seasonpass-pers-info__buy-tickets-modal">

            <SelectTickets
                administrativeFee={administrativeFee}
                ticketTemplates={event.ticketTemplates}
                maxSelectedObjects={1}
                pricing={event.ticketTemplates.map(({ categoryKey, ticketTemplateId, price }) => ({
                    category: categoryKey,
                    ticketTemplateId,
                    price: Math.max(price - oldTicketTemplate.price, 0),
                }))}
                tickets={state.tickets}
                onObjectSelected={onTicketAdded}
                onObjectDeselected={onObjectDeselected}
                hasSeats={true}
                workspaceKey={event.seatsIoWorkspaceId}
                eventSeatsId={event.seatsIoEventId}
                event={event}
                currency={getCurrencieLabel(event.currencyId)}
                total={paymentAmount}
                popupMode={true}
                isTermsChecked={isTermsChecked}
                handleChangeCheckbox={handleTermsChangeCheckbox}
                showTermsAndConditionsModal={showTermsAndConditionsModal}
                onSetChart={(c) => setChart(c)}
            />

            {state.isLoading
                && <NewLoader />}

        </div>

        <div className='swal2-actions'>

            <button className="swal2-cancel swal2-styled"
                onClick={() => MySwal.close()}>
                {txt.generalTxt.cancel}
            </button>

            <button disabled={!state.tickets.length || state.isLoading || !isTermsChecked} className="swal2-confirm swal2-styled"
                onClick={confirmHandler}>
                {txt.generalTxt.buy}
            </button>

        </div>

    </section>
}